module.exports = "/_next/static/images/wsprite-afb8041e39102b088149ef1feddd8fe8.png";